'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _filter2 = require('./internal/_filter');

var _filter3 = _interopRequireDefault(_filter2);

var _curry = require('./curry');

var _curry2 = _interopRequireDefault(_curry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function difference(toRemove, subject) {
  if (!toRemove) {
    return subject;
  }
  return (0, _filter3.default)(function (value) {
    return !toRemove.contains(value);
  }, subject);
}

/**
 * Take the difference between one iterable and another iterable.
 * Only the elements present in just subject will remain.
 *
 * @example
 * const removeOne = difference(Set.of(1));
 *
 * removeOne(Set.of(1, 2, 3)) // returns Set { 2, 3 }
 *
 * @param  {Iterable} toRemove
 * @param  {Iterable} subject
 * @return {Iterable}
 */
exports.default = (0, _curry2.default)(difference);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/difference.js
// module id = 346
// module chunks = 0 1